import Colors from "../useclass/colors";
import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";
import { useSnackbar } from "notistack";
import useIsMountedRef from "../utils/mountedRef";
import Mail from "../components/mail/mail";
import Memo from "../assets/docs/Memo_d_utilisation.pdf";
import { ToolTipPerso } from "./../components/selects/tooltip_perso";

function Home() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [categoriesOther, setCategoriesOther] = useState([]);
  const [simulateurs, setSimulateurs] = useState([]);
  const [allFavoris, setAllFavoris] = useState(localStorage.getItem("favoris"));
  const [categories, setCategories] = useState([]);
  const isMountedRef = useIsMountedRef();
  const dmtg = [55, 56, 109, 110];
  const others = [42, 103, 104, 105, 106];

  useEffect(() => {
    var config = {
      method: "get",
      url: `${API_BASE_URL}/categories`,
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("user"))?.jwt,
      },
    };
    axios(config).then((response) => {
      // response.data renvoie directement le token sans json il faut donc stocker le token en async storage et faire la securité sur les autres pages si l'utilisateurs 'nest pas connecté
      if (response.status === 200 && response.data != null) {
        if (isMountedRef.current) {
          setCategories(response.data);
        }
      } else {
        enqueueSnackbar("Une erreur est survenue", {
          variant: "error",
        });
      }
    });
  }, [isMountedRef]);

  useEffect(() => {
    var others = {
      method: "get",
      url: `${API_BASE_URL}/categories/autres`,
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("user"))?.jwt,
      },
    };
    axios(others).then((response) => {
      // response.data renvoie directement le token sans json il faut donc stocker le token en async storage et faire la securité sur les autres pages si l'utilisateurs 'nest pas connecté
      if (response.status === 200 && response.data != null) {
        if (isMountedRef.current) {
          setCategoriesOther(response.data.subcategories);
        }
      } else {
        enqueueSnackbar("Une erreur est survenue", {
          variant: "error",
        });
      }
    });
  }, [isMountedRef]);

  useEffect(() => {
    var simulateurs = {
      method: "get",
      url: `${API_BASE_URL}/simulateurs`,
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("user"))?.jwt,
      },
    };
    axios(simulateurs).then((response) => {
      // response.data renvoie directement le token sans json il faut donc stocker le token en async storage et faire la securité sur les autres pages si l'utilisateurs 'nest pas connecté
      if (response.status === 200 && response.data != null) {
        if (isMountedRef.current) {
          setSimulateurs(response.data);
          //console.log(simulateurs);
        }
      } else {
        enqueueSnackbar("Une erreur est survenue", {
          variant: "error",
        });
      }
    });
  }, [isMountedRef]);

  useEffect(() => {
    if (allFavoris !== null && allFavoris.length > 0) {
      try {
        setAllFavoris(JSON.parse(allFavoris));
      } catch (e) {}
    }
  }, [isMountedRef]);

  function returnStar(item) {
    if (allFavoris == null) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.847"
          height="19.011"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 512 512"
        >
          <path
            fill="none"
            stroke="#275d83"
            stroke-linejoin="round"
            stroke-width="32"
            d="M480 208H308L256 48l-52 160H32l140 96l-54 160l138-100l138 100l-54-160Z"
          />
        </svg>
      );
    }
    if (allFavoris.hasOwnProperty(item.id)) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.847"
          height="19.011"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 512 512"
        >
          <path
            fill="#275d83"
            d="M394 480a16 16 0 0 1-9.39-3L256 383.76L127.39 477a16 16 0 0 1-24.55-18.08L153 310.35L23 221.2a16 16 0 0 1 9-29.2h160.38l48.4-148.95a16 16 0 0 1 30.44 0l48.4 149H480a16 16 0 0 1 9.05 29.2L359 310.35l50.13 148.53A16 16 0 0 1 394 480Z"
          />
        </svg>
      );
    } else {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.847"
          height="19.011"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 512 512"
        >
          <path
            fill="none"
            stroke="#275d83"
            stroke-linejoin="round"
            stroke-width="32"
            d="M480 208H308L256 48l-52 160H32l140 96l-54 160l138-100l138 100l-54-160Z"
          />
        </svg>
      );
    }
  }

  function onClickFavoris(id) {
    var config = {
      method: "get",
      url: `${API_BASE_URL}/favoris/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("user")).jwt,
      },
    };
    axios(config).then((response) => {
      if (response.status === 200 && response.data != null) {
        localStorage.setItem("favoris", response.data);
        if (response.data !== null) setAllFavoris(JSON.parse(response.data));
        else setAllFavoris(response.data);
      }
    });
  }

  const styles = {
    bar: {
      backgroundColor: Colors.primaryBlue,
      width: 2,
      height: 30,
    },
    container: {
      width: "100%",
      color: Colors.textBlack,
      minHeight: "68vh",
    },
    containerCards: {
      // display: "grid",
      // gridGap: "30px 15px",
      // gridTemplateColumns: "repeat(3, 1fr)",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",

      width: "90%",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: 50,
    },
    containerItem: {
      display: "grid",
      gridTemplateColumns: "32px 12px 1fr",
      marginBottom: 15,
      lineHeight: 1.5,
    },
    card: {
      marginTop: 10,
      marginBottom: 30,
      backgroundColor: Colors.white,
      boxShadow: "2px 2px 1px rgba(0,0,0, 0.2)",
      //width: "95%",
      marginLeft: "auto",
      marginRight: "auto",
      borderRadius: 4,
      minWidth: 400,
      width: "30%",
    },

    starCard: {
      marginTop: 16,
      marginBottom: 16,
      paddingLeft: 20,
      paddingRight: 20,
    },

    cardHeader: {
      backgroundColor: Colors.lightGrey,
      borderRadius: "4px 4px 0px 0px",
      width: "100%",
      height: "auto",
      display: "grid",
      gridTemplateColumns: "1fr 3fr",
      paddingTop: 5,
      paddingBottom: 5,
    },
    cardHeaderBlue: {
      backgroundColor: Colors.primaryBlue,
      borderRadius: "4px 4px 0px 0px",
      width: "100%",
      height: "auto",
      display: "grid",
      gridTemplateColumns: "1fr 3fr",
      color: "white",
      paddingTop: 5,
      paddingBottom: 5,
    },
    logo: {
      marginTop: "auto",
      marginBottom: "auto",
      marginRight: "auto",
      marginLeft: 15,
    },
    list: {},
    listElem: {
      lineHeight: 1.8,
      cursor: "pointer",
    },
    listElemStar: {
      lineHeight: 1.8,
      listStyleType: "none",
      display: "flex",
      flexDirection: "row",
      cursor: "pointer",
    },
    liStar: {
      marginRight: 10,
      marginTop: 3,
    },
    cardBody: {
      maxHeight: 180,
      overflowY: "scroll",
    },
    cardTitle: {
      fontWeight: "normal",
      color: Colors.titleBlue,
    },
    cardTitleWhite: {
      fontWeight: "normal",
      color: "white",
      marginLeft: 15,
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.containerCards}>
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div style={styles.logo}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50.693"
                height="52.554"
                viewBox="0 0 50.693 52.554"
              >
                <path
                  id="Icon_ionic-ios-calculator"
                  data-name="Icon ionic-ios-calculator"
                  d="M52.806,3.375H13.074c-3.031,0-5.48,1.807-5.48,4.043V51.886c0,2.236,2.449,4.043,5.48,4.043H52.806c3.031,0,5.48-1.807,5.48-4.043V7.418C58.287,5.182,55.838,3.375,52.806,3.375ZM50.751,37.737V47.843c0,1.68-1.832,3.032-4.11,3.032h0c-2.278,0-4.11-1.352-4.11-3.032V37.737c0-1.68,1.832-3.032,4.11-3.032h0C48.919,34.705,50.751,36.057,50.751,37.737Zm0-10.106h0c0,1.68-1.832,3.032-4.11,3.032h0c-2.278,0-4.11-1.352-4.11-3.032h0c0-1.68,1.832-3.032,4.11-3.032h0C48.919,24.6,50.751,25.95,50.751,27.631Zm-13.7,20.213h0c0,1.68-1.832,3.032-4.11,3.032h0c-2.278,0-4.11-1.352-4.11-3.032h0c0-1.68,1.832-3.032,4.11-3.032h0C35.218,44.811,37.051,46.163,37.051,47.843Zm0-10.106h0c0,1.68-1.832,3.032-4.11,3.032h0c-2.278,0-4.11-1.352-4.11-3.032h0c0-1.68,1.832-3.032,4.11-3.032h0C35.218,34.705,37.051,36.057,37.051,37.737Zm0-10.106h0c0,1.68-1.832,3.032-4.11,3.032h0c-2.278,0-4.11-1.352-4.11-3.032h0c0-1.68,1.832-3.032,4.11-3.032h0C35.218,24.6,37.051,25.95,37.051,27.631ZM23.35,47.843h0c0,1.68-1.832,3.032-4.11,3.032h0c-2.278,0-4.11-1.352-4.11-3.032h0c0-1.68,1.832-3.032,4.11-3.032h0C21.517,44.811,23.35,46.163,23.35,47.843Zm0-10.106h0c0,1.68-1.832,3.032-4.11,3.032h0c-2.278,0-4.11-1.352-4.11-3.032h0c0-1.68,1.832-3.032,4.11-3.032h0C21.517,34.705,23.35,36.057,23.35,37.737Zm0-10.106h0c0,1.68-1.832,3.032-4.11,3.032h0c-2.278,0-4.11-1.352-4.11-3.032h0c0-1.68,1.832-3.032,4.11-3.032h0C21.517,24.6,23.35,25.95,23.35,27.631Zm-8.22-10.106V11.46c0-1.112,1.233-2.021,2.74-2.021H48.011c1.507,0,2.74.91,2.74,2.021v6.064c0,1.112-1.233,2.021-2.74,2.021H17.869C16.362,19.545,15.129,18.636,15.129,17.524Z"
                  transform="translate(-7.594 -3.375)"
                  fill="#275d83"
                />
              </svg>
            </div>

            <h2 style={styles.cardTitle}>Calculs de frais</h2>
          </div>

          <div style={styles.cardBody}>
            <ul>
              {categories.map((value) => {
                if (value.categorie_id == 1) {
                  return (
                    <li
                      style={styles.listElem}
                      onClick={() =>
                        (window.location = `/categorie/${value.url_name}`)
                      }
                    >
                      {value.categorie_name}
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        </div>

        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div style={styles.logo}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="66.425"
                height="58.128"
                viewBox="0 0 66.425 58.128"
              >
                <path
                  id="Icon_awesome-cubes"
                  data-name="Icon awesome-cubes"
                  d="M63.389,30.56l-12.532-4.7V11.787a4.67,4.67,0,0,0-3.036-4.372L34.847,2.55a4.615,4.615,0,0,0-3.282,0L18.591,7.415a4.67,4.67,0,0,0-3.036,4.372V25.863L3.023,30.56A4.676,4.676,0,0,0,0,34.932V49.216a4.675,4.675,0,0,0,2.582,4.177L15.555,59.88a4.644,4.644,0,0,0,4.177,0l13.48-6.746,13.48,6.746a4.644,4.644,0,0,0,4.177,0l12.974-6.487a4.675,4.675,0,0,0,2.582-4.177V34.932a4.67,4.67,0,0,0-3.036-4.372ZM46.445,25.967,35.418,30.106V21.258l11.028-4.8ZM19.979,11.605,33.212,6.65l13.233,4.956v.078L33.212,17.054,19.979,11.683Zm10.9,37.766L19.85,54.885V44.623l11.028-5.034Zm0-14.53L17.644,40.212,4.411,34.841v-.078l13.233-4.956,13.233,4.956Zm31.137,14.53L50.986,54.885V44.623l11.028-5.034Zm0-14.53L48.781,40.212,35.548,34.841v-.078l13.233-4.956,13.233,4.956Z"
                  transform="translate(0 -2.248)"
                  fill="#275d83"
                />
              </svg>
            </div>
            <h2 style={styles.cardTitle}>Simulateurs</h2>
          </div>
          <div style={styles.cardBody}>
            <ul>
              {categoriesOther.length > 0 ? (
                categoriesOther["0"].simulateur.map((value) => {
                  if (value.id != 107 && value.id != 108 && value.id != 105 && value.id != 113 && value.id != 116 && value.id != 118) {
                    return (
                      <li
                        style={styles.listElem}
                        onClick={() => {
                          if (dmtg.includes(value.id)) {
                            window.location = `/categorie/autres/dmtg/${value.id}`;
                          } else if (others.includes(value.id)) {
                            window.location = `/categorie/autres/others/${value.id}`;
                          }
                        }}
                      >
                        {value.name}
                      </li>
                    );
                  }
                })
              ) : (
                <></>
              )}
            </ul>
          </div>
        </div>

        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div style={styles.logo}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="55.104"
                height="51.168"
                viewBox="0 0 55.104 51.168"
              >
                <path
                  id="Icon_ionic-ios-star"
                  data-name="Icon ionic-ios-star"
                  d="M55.263,21.087H37.17l-5.5-16.408a1.992,1.992,0,0,0-3.739,0l-5.5,16.408H4.218A1.974,1.974,0,0,0,2.25,23.055a1.446,1.446,0,0,0,.037.332,1.891,1.891,0,0,0,.824,1.39l14.871,10.48L12.274,51.849a1.974,1.974,0,0,0,.676,2.214,1.9,1.9,0,0,0,1.107.48,2.411,2.411,0,0,0,1.23-.443L29.8,43.756,44.316,54.1a2.3,2.3,0,0,0,1.23.443,1.767,1.767,0,0,0,1.095-.48,1.95,1.95,0,0,0,.676-2.214L41.61,35.256,56.357,24.678l.357-.307a2.063,2.063,0,0,0,.64-1.316A2.083,2.083,0,0,0,55.263,21.087Z"
                  transform="translate(-2.25 -3.375)"
                  fill="#275d83"
                />
              </svg>
            </div>
            <h2 style={styles.cardTitle}>Mes actes favoris</h2>
          </div>
          <div style={styles.cardBody}>
            <div style={styles.starCard}>
              {allFavoris ? (
                simulateurs.map((sim) => {
                  let favoris = Object.values(allFavoris);
                  if (favoris.includes(sim.id.toString())) {
                    return (
                      <li style={styles.listElemStar}>
                        <div style={styles.containerItem}>
                          <div
                            style={styles.star}
                            onClick={(e) => onClickFavoris(sim.id)}
                          >
                            {returnStar(sim)}
                          </div>
                          <div style={styles.bar}></div>
                          <div
                            style={styles.bodyText}
                            onClick={() => {
                              if (dmtg.includes(sim.id)) {
                                window.location = `/categorie/${sim.subcategorie[0].categorie.url_name}/dmtg/${sim.id}`;
                              } else if (others.includes(sim.id)) {
                                window.location = `/categorie/${sim.subcategorie[0].categorie.url_name}/others/${sim.id}`;
                              } else {
                                window.location = `/categorie/${sim.subcategorie[0].categorie.url_name}/simulateur/${sim.id}`;
                              }
                            }}
                          >
                            {sim.shortname}
                          </div>
                        </div>
                      </li>
                    );
                  }
                })
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>

        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div style={styles.logo}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="53"
                height="53"
                viewBox="0 0 53 53"
              >
                <path
                  id="Icon_ionic-ios-information-circle"
                  data-name="Icon ionic-ios-information-circle"
                  d="M29.875,3.375a26.5,26.5,0,1,0,26.5,26.5A26.5,26.5,0,0,0,29.875,3.375ZM32.3,42.106H27.429V23.747H32.3ZM29.862,21.747A2.543,2.543,0,1,1,32.5,19.2,2.554,2.554,0,0,1,29.862,21.747Z"
                  transform="translate(-3.375 -3.375)"
                  fill="#275d83"
                />
              </svg>
            </div>
            <h2 style={styles.cardTitle}>Pour aller plus loin</h2>
          </div>
          <div style={styles.cardBody}>
            <ul>
              <li
                style={styles.listElem}
                onClick={() => (window.location = `/fiches`)}
              >
                Fiches pratiques
              </li>

              <li
                style={styles.listElem}
                onClick={() => (window.location = `/infos`)}
              >
                Informations sur les barèmes
              </li>
            </ul>
          </div>
        </div>

        <div style={styles.card}>
          <div style={styles.cardHeaderBlue}>
            <div style={styles.logo}>
              <svg
                id="Calque_1"
                data-name="Calque 1"
                xmlns="http://www.w3.org/2000/svg"
                width="110"
                height="61"
                viewBox="0 0 42.86 22.7"
              >
                <path
                  d="m22.1,10.55v2.23c0,.78.5.93,1.05.93.23,0,.56-.03.7-.06.06-.01.09-.03.09-.09v-.4s-.04-.09-.09-.09h-.74c-.2,0-.28-.07-.28-.29v-2.23s-.04-.09-.09-.09h-.56s-.09.04-.09.09m-17.76-.88c.49,1.2.85,1.59,1.19,2.06l3.1,1.83c.14-1,.46-1.49.94-2.15,0,0-2.49-.05-3.48-.76-.62-.44-1.85-2.18-1.85-2.18l.1,1.21Zm.46,3.17h-.12s-.03.02-.02.03l.19.26s.02.02.04.02h.09s.03-.01.02-.03l-.16-.26s-.02-.02-.03-.02m2.61,1.12v-.24c0-.17.09-.28.26-.28s.26.11.26.27c0,.15-.1.25-.26.25h-.26Zm0,.32v-.17h.26c.25,0,.42-.17.42-.4,0-.24-.17-.42-.42-.42s-.42.18-.42.43v.56c0,.26.17.43.42.43s.41-.17.42-.43c0-.02-.01-.03-.03-.03h-.1s-.03,0-.03.03c0,.17-.11.28-.26.28-.16,0-.26-.12-.26-.28m-.06,1.82c0-.17.09-.28.26-.28s.26.11.26.27c0,.15-.1.25-.26.25h-.26v-.24Zm-.16,0v.56c0,.26.17.43.42.43s.41-.17.42-.43c0-.02-.01-.03-.03-.03h-.1s-.03,0-.03.03c0,.17-.11.28-.26.28-.16,0-.26-.12-.26-.28v-.17h.26c.25,0,.42-.17.42-.4,0-.24-.17-.42-.42-.42s-.42.18-.42.43m-1.08,0c0-.16.1-.28.26-.28s.26.12.26.28v.56c0,.16-.1.28-.26.28s-.26-.12-.26-.28v-.56Zm-.16,0v.56c0,.25.17.43.42.43s.42-.18.42-.43v-1.49s-.01-.03-.03-.03h-.1s-.03.01-.03.03v.63c-.07-.08-.16-.14-.26-.14-.25,0-.42.18-.42.43m-.39-1.43s.01.03.03.03h.1s.03-.01.03-.03v-.94c0-.16.08-.28.24-.28s.24.12.24.28v.94s.01.03.03.03h.1s.03-.01.03-.03v-.94c0-.16.08-.28.24-.28s.24.12.24.28v.94s.01.03.03.03h.1s.03-.01.03-.03v-.94c0-.25-.15-.43-.39-.43-.14,0-.25.08-.31.21-.06-.12-.17-.21-.31-.21-.24,0-.39.18-.39.43v.94Zm-.15,1.03s-.03.01-.03.03v1.31s.01.03.03.03h.1s.03-.01.03-.03v-1.31s-.01-.03-.03-.03h-.1Zm-.06-.29c0,.06.04.11.11.11s.11-.05.11-.11c0-.06-.05-.11-.11-.11s-.11.04-.11.11m-.71-1.44v-.24c0-.17.09-.28.26-.28s.26.11.26.27c0,.15-.1.25-.26.25h-.26Zm.26.75c.24,0,.41-.17.42-.43,0-.02-.01-.03-.03-.03h-.1s-.03,0-.03.03c0,.17-.11.28-.26.28-.16,0-.26-.12-.26-.28v-.17h.26c.25,0,.42-.17.42-.4,0-.24-.17-.42-.42-.42s-.42.18-.42.43v.56c0,.26.17.43.42.43m-.64,1.38c0-.16.1-.28.26-.28s.26.12.26.28v.56c0,.16-.1.28-.26.28s-.26-.12-.26-.28v-.56Zm-.16,0v1.49s.01.03.03.03h.1s.03-.01.03-.03v-.63c.07.08.16.14.29.14.23,0,.39-.18.39-.43v-.56c0-.25-.17-.43-.42-.43s-.42.18-.42.43m-.3-2.36v.93s.01.03.03.03h.1s.03-.01.03-.03v-.93c0-.17.11-.27.27-.27h.12s.03-.01.03-.03v-.1s-.01-.03-.03-.03h-.12c-.25,0-.43.17-.43.42m-.79,2.93c0-.13.1-.24.26-.24h.27v.24c0,.16-.1.27-.26.27s-.27-.11-.27-.27m-.16,0c0,.24.17.42.42.42s.42-.18.42-.42v-.57c0-.24-.16-.42-.41-.42-.24,0-.39.17-.4.4,0,.02.01.03.03.03h.1s.02,0,.03-.03c.01-.15.1-.25.25-.25.16,0,.26.12.26.27v.18h-.27c-.25,0-.42.18-.42.39m-1.11-1.05c0-.2.12-.34.28-.34s.29.14.29.34v.2c0,.19-.12.33-.29.33h-.28v-.53Zm-.16,0v1.42s.01.03.03.03h.11s.03-.01.03-.03v-.74h.3l.3.74s.02.02.03.02h.12s.03-.01.02-.03l-.31-.76c.16-.07.28-.22.28-.45v-.2c0-.29-.18-.49-.45-.49s-.45.21-.45.49m.14-3.3s.03-.01.03-.03v-1.86s-.01-.03-.03-.03h-.1s-.03.01-.03.03v1.86s.01.03.03.03h.1Zm.56,1.02c0,.19-.1.3-.27.3h-.25v-.44c0-.19.1-.3.26-.3.17,0,.27.11.27.3v.13Zm-.53.46h.29c.18,0,.28.12.28.31v.13c0,.19-.1.31-.28.31h-.29v-.75Zm.26-1.05c-.25,0-.42.18-.42.46v1.41s.03.08.08.08h.38c.27,0,.45-.18.45-.46v-.13c0-.19-.11-.35-.27-.4.14-.04.23-.18.23-.37v-.13c0-.27-.17-.46-.44-.46m.7-1.4c0,.15-.1.25-.26.25h-.26v-.24c0-.17.09-.28.26-.28s.26.11.26.27m.16,0c0-.24-.17-.42-.42-.42s-.42.18-.42.43v.56c0,.26.17.43.42.43s.41-.17.42-.43c0-.02-.01-.03-.03-.03h-.1s-.03,0-.03.03c0,.17-.11.28-.26.28-.16,0-.26-.12-.26-.28v-.17h.26c.25,0,.42-.17.42-.4m.51,2.95c0,.16-.1.27-.26.27s-.27-.11-.27-.27c0-.13.1-.24.26-.24h.27v.24Zm-.26-1c-.24,0-.39.17-.4.4,0,.02.01.03.03.03h.1s.02,0,.03-.03c.01-.15.1-.25.25-.25.16,0,.26.12.26.27v.18h-.27c-.25,0-.42.18-.42.39,0,.24.17.42.42.42s.42-.18.42-.42v-.57c0-.24-.16-.42-.41-.42m.18-4.24c.23.48.79.54.79.54l-.24-2.23s-.96.82-.54,1.69m.87-1.45s.54-1.3.54-1.54c0-.4-.64-1.33-.64-1.33-.03.19-.43.81-.52,1.17-.09.36.62,1.7.62,1.7m2.13.22l-.19.56h-.61l.49.34-.18.55.48-.34.48.34-.18-.55.49-.34h-.61s-.18-.56-.18-.56Zm.96-1.5l.49-.34h-.61s-.19-.56-.19-.56l-.19.56h-.61l.49.34-.18.55.48-.34.48.34-.18-.55Zm1.93-1.77l.49-.34h-.61s-.19-.56-.19-.56l-.18.56h-.61l.49.34-.18.55.48-.34.48.34-.18-.55Zm2.42-.67l.49-.34h-.61s-.19-.56-.19-.56l-.19.56h-.61l.49.34-.18.55.48-.34.48.34-.18-.55Zm.64,3.67l.4-1.47-1.03,1.07-.36-1.25-.36,1.29-1.06-1.1.4,1.47s-1.6-.46-1.56-.44l1.02.99-1.51.15,1.44.65-.83.88s.67-.1,1.14-.18c0,.05,0,.1,0,.15,0,1,.6,1.81,1.33,1.81s1.33-.81,1.33-1.81c0-.05,0-.09,0-.14.47.08,1.13.19,1.1.17l-.83-.88,1.44-.65-1.51-.15,1.02-.99s-1.56.44-1.56.44m1.85-3.01l.49-.34h-.61s-.19-.56-.19-.56l-.19.56h-.61l.49.34-.18.55.48-.34.48.34-.18-.55Zm1.73,1.82l.49-.34h-.61s-.19-.56-.19-.56l-.19.56h-.61l.49.34-.18.55.48-.34.48.34-.18-.55Zm.96,2.99l-.18-.55.49-.34h-.61s-.19-.56-.19-.56l-.19.56h-.61l.49.34-.18.55.48-.34.48.34Zm-.34,2.33l-.18-.55.49-.34h-.61s-.19-.56-.19-.56l-.19.56h-.61l.49.34-.18.55.48-.34.48.34Zm-1.23.99l-.49.34.18.55-.48-.34-.48.34.18-.55-.49-.34h.61l.19-.56.19.56h.61Zm-.3,4.09c2.24-.29,1.11-6.06-1.93-5.54-1.21.21-2.12,2.1-2.99,2.07-.91-.03-.09-1.97-.09-1.97,0,0-.83.91-1.01,1.91-.29,1.62.31,2.16,1.14,2.34,1.33.3,2.18-1.31,3.53-1.45,1.58-.17,1.35,2.63,1.35,2.63m-.22,0s.07-.89-.18-1.62c0,0-2.41,1.09-2.81.88-1.4-.73-1.8.74-1.8.74h4.79Zm-5.1,1.88c.33.01,5.11,0,5.11,0-.29-.09-.29-1.49-.05-1.6h-5.05c-.53.02-.43,1.58,0,1.59m9.93-1.69l-9.69,5.6L.14,16.95V5.75L9.83.16l9.69,5.6v11.19Zm-9.69,5.75l9.83-5.68V5.68L9.83,0,.03,5.66l-.03.02v11.35l9.83,5.68ZM23.82,5.28s.02-.03.02-.03c0-.02-.02-.03-.05-.03h-.56c-.06,0-.08.02-.12.06l-.4.5s-.02.03-.02.04c0,.02.01.03.04.03h.46c.06,0,.07-.02.1-.05l.52-.53Zm.22,3.89v-.4s-.04-.09-.09-.09h-.87c-.2,0-.27-.07-.27-.29v-.46h1.11s.09-.04.09-.09v-.41s-.04-.09-.09-.09h-1.11v-.39c0-.22.07-.29.27-.29h.87s.09-.04.09-.09v-.4c0-.06-.03-.08-.09-.09-.15-.02-.36-.06-.82-.06-.55,0-1.04.14-1.04.92v1.43c0,.78.49.93,1.04.93.46,0,.68-.03.83-.06.06,0,.09-.03.09-.09m1.12,3.12l.26-1.19s.02-.06.06-.06.05.02.06.06l.26,1.19h-.64Zm-.39-1.39l-.64,2.67s0,.02,0,.02c0,.04.03.07.07.07h.6s.08-.03.09-.08l.15-.71h.88l.15.71s.04.08.09.08h.6s.07-.03.07-.07c0,0,0-.01,0-.02l-.64-2.67c-.1-.41-.41-.48-.71-.48s-.62.06-.72.48m1.78-2.95c0,.58-.25.74-.63.74-.11,0-.24,0-.3,0v-2.01c.06,0,.2,0,.3,0,.38,0,.63.16.63.74v.56Zm.73,0v-.56c0-.91-.51-1.36-1.36-1.36-.35,0-.73.03-.91.06-.08.01-.12.05-.12.15v2.85c0,.1.04.14.12.15.18.03.55.06.91.06.85,0,1.36-.45,1.36-1.36m1.54,1.24v-3.03s-.03-.08-.08-.08h-.57s-.08.03-.08.08v3.03s.03.09.08.09h.57s.08-.04.08-.09m.86,1.27h-.51s-.09.03-.09.08v1.82s-.01.04-.02.04c-.01,0-.02,0-.03-.03l-1.02-1.77c-.05-.09-.09-.13-.18-.13h-.44c-.09,0-.16.07-.16.16v2.95s.04.09.09.09h.51s.09-.04.09-.09v-1.74s0-.03.02-.03.02,0,.04.03l.98,1.7c.07.12.13.13.22.13h.42c.09,0,.17-.07.17-.16v-2.95s-.04-.08-.09-.08m2.14-3.86v-.44s-.04-.08-.09-.08h-2.12s-.09.03-.09.08v.44s.04.08.09.08h.7v2.51s.04.09.09.09h.56s.09-.04.09-.09v-2.51h.69s.09-.03.09-.08m.67,3.92c-.16-.03-.47-.1-.9-.1-.62,0-1.31.28-1.31,1.37v.53c0,1.09.74,1.37,1.23,1.37.43,0,.73-.04.96-.09.06-.01.09-.04.09-.1v-1.45s-.04-.09-.09-.09h-.55s-.08.04-.08.09v.99c-.1,0-.21.01-.33.01-.21,0-.48-.14-.48-.73v-.54c0-.56.22-.73.56-.73.37,0,.69.03.9.03h.01s.06,0,.06-.06v-.46s-.03-.06-.07-.06m.76-1.33v-3.03s-.03-.08-.08-.08h-.57s-.08.03-.08.08v3.03s.03.09.08.09h.57s.08-.04.08-.09m.91,3.88c-.2,0-.28-.07-.28-.29v-2.23s-.04-.09-.09-.09h-.56s-.09.04-.09.09v2.23c0,.78.5.93,1.05.93.23,0,.56-.03.7-.06.06-.01.09-.03.09-.09v-.4s-.04-.09-.09-.09h-.74Zm1.71-5.13c0,.52-.17.74-.53.74s-.52-.22-.52-.74v-.51c0-.52.17-.74.52-.74s.53.22.53.74v.51Zm.73,0v-.51c0-1-.56-1.38-1.26-1.38s-1.26.38-1.26,1.38v.51c0,1,.56,1.38,1.26,1.38s1.26-.38,1.26-1.38m.39,4.39c0,.52-.17.74-.53.74s-.53-.22-.53-.74v-.51c0-.52.17-.74.53-.74s.53.22.53.74v.51Zm.74-.51c0-1-.56-1.38-1.27-1.38s-1.27.38-1.27,1.38v.51c0,1,.56,1.38,1.27,1.38s1.27-.38,1.27-1.38v-.51Zm2.21-2.69v-2.95s-.04-.08-.09-.08h-.5s-.09.03-.09.08v1.82s-.01.04-.02.04c-.01,0-.02,0-.03-.03l-1.01-1.77c-.05-.09-.09-.13-.18-.13h-.43c-.09,0-.16.07-.16.16v2.95s.04.09.09.09h.5s.09-.04.09-.09v-1.74s0-.03.02-.03.02,0,.04.03l.97,1.7c.07.12.13.13.22.13h.42c.09,0,.17-.07.17-.16m-1.45.54s-.09.04-.09.09v.4s.05.09.09.09h.4s.09-.04.09-.09v-.4s-.04-.09-.09-.09h-.4Zm.84.09v.4s.04.09.09.09h.4s.09-.04.09-.09v-.4s-.05-.09-.09-.09h-.4s-.09.04-.09.09m1.13.82s0-.02,0-.03c0-.03-.03-.06-.07-.06h-.62s-.07.03-.09.07l-.47,1.21c-.02.06-.03.06-.06.06s-.04,0-.06-.06l-.47-1.21s-.04-.07-.09-.07h-.62s-.07.03-.07.06c0,0,0,.02,0,.03l.65,1.49c.09.2.18.29.28.33v1.2s.04.09.09.09h.56s.09-.04.09-.09v-1.2c.1-.04.19-.13.28-.33l.65-1.49Zm1.62,2.21c0,.21-.09.3-.38.3-.17,0-.64-.03-.82-.05h-.01s-.08.02-.08.08v.42s.04.07.09.09c.22.06.47.09.81.09.87,0,1.18-.49,1.18-.94,0-.35-.13-.63-.58-.87l-.55-.3c-.23-.12-.29-.18-.29-.3,0-.16.09-.23.34-.23.29,0,.79.04.91.05h0c.06,0,.07-.03.07-.07v-.43s-.03-.07-.06-.08c-.16-.04-.6-.09-.91-.09-.84,0-1.1.37-1.1.84,0,.31.11.59.51.82l.59.35c.22.13.28.2.28.33m-.62-5.87c0-.15.09-.23.33-.23.29,0,.79.04.9.05h0c.06,0,.07-.03.07-.07v-.43s-.03-.07-.06-.08c-.16-.04-.59-.09-.9-.09-.83,0-1.09.37-1.09.84,0,.31.11.59.5.82l.59.35c.22.13.28.2.28.33,0,.21-.09.3-.38.3-.17,0-.64-.03-.81-.05h-.01s-.08.02-.08.08v.42s.04.07.09.09c.22.06.47.09.81.09.87,0,1.16-.49,1.16-.94,0-.35-.13-.63-.58-.87l-.55-.3c-.23-.12-.29-.18-.29-.3"
                  fill="#fff"
                />
                <g>
                  <path
                    d="m22.54,16.63c-.14,0-.29,0-.35-.02-.02,0-.04-.02-.04-.05v-1.31s.02-.04.04-.05c.06,0,.2-.02.35-.02.35,0,.58.18.58.59v.26c0,.41-.22.59-.58.59Zm.4-.85c0-.34-.17-.44-.4-.44-.09,0-.15,0-.21,0v1.13c.06,0,.12,0,.21,0,.23,0,.4-.1.4-.44v-.26Z"
                    fill="#fff"
                  />
                  <path
                    d="m24.32,16.15h-.64v.03c0,.23.09.31.26.31.11,0,.25,0,.34-.02h0s.03,0,.03.03v.06s0,.04-.04.04c-.11.02-.21.03-.34.03-.22,0-.43-.1-.43-.46v-.17c0-.27.15-.44.42-.44s.42.17.42.44v.1s-.01.04-.04.04Zm-.13-.14c0-.21-.08-.3-.25-.3s-.25.09-.25.3v.02h.5v-.02Z"
                    fill="#fff"
                  />
                  <path
                    d="m25.16,16.63c-.06,0-.15,0-.22-.02v.34s-.02.04-.04.04h-.1s-.03-.02-.03-.04v-1.31s0-.04.04-.04c.1-.02.23-.04.35-.04.28,0,.41.18.41.47v.14c0,.3-.14.47-.41.47Zm.25-.6c0-.2-.06-.33-.25-.33-.08,0-.17,0-.22.02v.75c.06.01.16.02.22.02.19,0,.25-.12.25-.32v-.14Z"
                    fill="#fff"
                  />
                  <path
                    d="m26.75,16.62h-.1s-.04-.02-.04-.04v-.04c-.1.06-.19.09-.3.09-.23,0-.33-.14-.33-.4v-.62s.02-.04.04-.04h.09s.04.02.04.04v.62c0,.19.06.25.21.25.08,0,.17-.03.26-.07v-.8s.02-.04.04-.04h.09s.04.02.04.04v.97s-.02.04-.04.04Z"
                    fill="#fff"
                  />
                  <path
                    d="m27.39,15.4h-.1s-.04-.02-.04-.04v-.15s.02-.04.04-.04h.1s.04.02.04.04v.15s-.02.04-.04.04Zm0,1.21h-.09s-.04-.02-.04-.04v-.97s.02-.04.04-.04h.09s.04.02.04.04v.97s-.02.04-.04.04Z"
                    fill="#fff"
                  />
                  <path
                    d="m28.2,16.63c-.07,0-.21,0-.3-.03-.02,0-.04-.02-.04-.04v-.07s.02-.03.03-.03h0c.09.01.23.02.3.02.12,0,.19-.03.19-.13,0-.06-.03-.09-.14-.16l-.19-.11c-.12-.07-.19-.15-.19-.27,0-.2.15-.25.34-.25.11,0,.21,0,.3.02.02,0,.04.02.04.04v.06s-.01.03-.03.03h0c-.07,0-.19-.02-.29-.02s-.18.01-.18.11c0,.06.04.09.13.14l.19.11c.16.09.21.17.21.29,0,.19-.14.28-.36.28Z"
                    fill="#fff"
                  />
                  <path
                    d="m29.67,16.62s-.04-.01-.04-.03v-.08s.02-.03.04-.03h.3v-1.08l-.3.13s-.04.01-.04-.02v-.1s0-.02.02-.02l.34-.16s.03-.01.04-.01h.08s.04.02.04.04v1.23h.3s.04.01.04.03v.08s-.02.03-.04.03h-.78Z"
                    fill="#fff"
                  />
                  <path
                    d="m31.36,16.63c-.15,0-.25-.02-.33-.03-.02,0-.05-.01-.05-.04v-.07s.02-.03.03-.03c0,0,0,0,.01,0,.1.02.21.03.32.03.29,0,.33-.17.33-.42v-.02c-.08.02-.17.04-.29.04-.25,0-.47-.09-.47-.4h0c0-.31.15-.49.46-.49.28,0,.46.17.46.54v.33c0,.41-.17.57-.5.57Zm.33-.9c0-.31-.1-.4-.29-.4s-.29.08-.29.34h0c0,.22.14.27.29.27.09,0,.22-.02.29-.03v-.18Z"
                    fill="#fff"
                  />
                  <path
                    d="m32.69,16.63c-.12,0-.24-.01-.33-.03-.02,0-.04-.01-.04-.04v-.07s.01-.03.03-.03h0c.12.02.24.03.33.03.21,0,.31-.1.31-.3v-.03c0-.19-.12-.25-.4-.25h-.23s-.03-.02-.03-.03h0s.05-.63.05-.63c0-.02.02-.03.04-.03h.65s.04.01.04.03v.08s-.02.03-.04.03h-.55l-.03.41h.09c.35,0,.57.09.57.4v.03c0,.28-.18.44-.48.44Z"
                    fill="#fff"
                  />
                  <path
                    d="m34.09,16.63c-.28,0-.46-.17-.46-.54v-.33c0-.41.17-.57.5-.57.15,0,.25.02.33.03.02,0,.04.01.04.04v.07s-.02.03-.03.03c0,0,0,0-.01,0-.1-.02-.2-.03-.33-.03-.29,0-.32.17-.32.42v.02c.08-.02.17-.04.29-.04.25,0,.47.09.47.4h0c0,.31-.15.49-.46.49Zm.29-.49c0-.21-.14-.26-.29-.26-.09,0-.22.02-.29.03v.18c0,.31.1.4.29.4s.29-.08.29-.34h0Z"
                    fill="#fff"
                  />
                </g>
              </svg>
            </div>

            <h2 style={styles.cardTitleWhite}>Les Éditions Langloÿs</h2>
          </div>
          <div style={styles.cardBody}>
            <ul>
              <li
                style={styles.listElem}
                onClick={() =>
                  window.open("https://editionslangloys.com", "_blank")
                }
              >
                Découvrir l'ensemble de nos produits
              </li>
              <li
                style={styles.listElem}
                onClick={() =>
                  window.open("https://editionslangloys.com/boutique", "_blank")
                }
              >
                Commander sur la boutique en ligne
              </li>
              <li
                style={styles.listElem}
                onClick={() => window.open(Memo, "_blank")}
              >
                Mémo d'utilisation
              </li>
            </ul>
          </div>
        </div>

        <Mail floatItem={false} />
      </div>
    </div>
  );
}

export default Home;
